import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(private)/videos/[videoId]/controls/AdditionalVideoControls.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(private)/videos/[videoId]/controls/LexemesFilterControl.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(private)/videos/[videoId]/controls/ToggleFavorite.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(private)/videos/[videoId]/controls/ToggleIsStudying.tsx");
